import axios from 'axios';
import config from 'config';

let instance;

export default function apiClient() {
  if (!instance) {
    instance = axios.create({
      baseURL: `https://${config.apiHost}:${config.apiPort}`,
      timeout: 1000 * 20,
      withCredentials: true,
    });

    let token;

    instance.setJwtToken = newToken => {
      token = newToken;
    };

    instance.interceptors.request.use(
      conf => {
        if (token) {
          conf.headers.Authorization = token;
        }

        return conf;
      },
      error => Promise.reject(error)
    );

    instance.interceptors.response.use(
      response => response.data,
      error => Promise.reject(error.response ? { status: error.response.status, ...error.response.data } : error)
    );
  }
  return instance;
}
